  
import {ReactNode} from 'react';

  
import {Dialog, DialogContent, DialogProps} from '@mui/material';

type NewJobPostingDialogPropsType = {
  open: boolean;
  maxWidth?: DialogProps['maxWidth'];
  onClose(_event: React.MouseEvent, reason: string): void;
  children: ReactNode;
};

export const NewJobPostingDialog = ({open, maxWidth = 'lg', onClose, children}: NewJobPostingDialogPropsType) => {
  return (
    <Dialog
      disableEscapeKeyDown
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          height: '90%',
          maxHeight: '100%',
          backgroundImage: 'none',
        },
      }}
    >
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};
